import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InvestorLandingPage from "./components/InvestorLandingPage";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<InvestorLandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
